import Vue from 'vue';
import VueRouter from 'vue-router';
// import store from '../store/index';

import autoLogin from '../util/autoLogin.js';

// import EmptyPage from '../view/EmptyPage';
// import priceReport from '../view/cloud/priceReport';
// import StorageList from '../view/cloud/CloudStoreManage.vue';
// import ImportAndExport from '../view/cloud/ImportAndExport.vue';
// import goodsManage from '../view/cloud/CloudGoodsManage.vue'
// import ImportAndExportRecord from '../view/cloud/ImportAndExportRecord.vue'
// import QueryOrder from '../view/cloud/OrderQuery.vue'
// import ProductOrder from '../view/cloud/ProductOrder.vue'
// import SortPacking from '../view/cloud/SortPacking.vue'
// import DesignOrder from '../view/cloud/DesignOrder.vue'
// import orderDetail from '../view/cloud/orderDetail.vue'
// import deliverGoodsOrder from '../view/cloud/deliverGoodsOrder.vue'
import showRoom from '../view/cloud/showRoom1.vue'
import TheWorld from '../view/theWorldBox.vue'
// import Administrator from '../view/cloud/administratorBackground.vue'
// import ColorCardManage from '../view/cloud/CloudColorCardManage.vue'
// import PersonalColorCard from '../view/cloud/PersonalColorCard.vue'
import TableShopCar from '../view/cloud/TableShopCar.vue'
// import OrderPayment from '../view/cloud/OrderPayment.vue'
// import VipSystem from '../view/cloud/vipSystem.vue'
// import BatchRevise from '../view/cloud/BatchRevise.vue'
// import ColorList from '../view/cloud/CloudColorManage.vue'
// import clientManage from '../view/cloud/clientManage.vue'
// import staffManage from '../view/cloud/staffManage.vue'
// import FinancialManage from '../view/cloud/FinancialManage.vue'
// import CollectionRecords from '../components/cloud/cloudFinancialManage/collectionRecords.vue'
// import FinancialReports from '../components/cloud/cloudFinancialManage/financialReports.vue'
// import PaymentRecords from '../components/cloud/cloudFinancialManage/paymentRecords.vue'
// import AddOrderManually from '../view/cloud/AddOrderManually.vue'
// import AddPurchaseOrderManually from '../view/cloud/AddPurchaseOrderManually.vue'
import VipService from '../view/cloud/VipService.vue'
import PersonCenter from '../view/cloud/CloudPersonCenter.vue'
// import House from '../view/House.vue'
// import MeasureAndInstall from '../view/measureAndInstall.vue'
import AboutCloud from '../view/cloud/aboutCloud.vue'
import MoreVipServer from '../view/cloud/MoreVipServer.vue'
import Shop from '../view/cloud/CloudShop.vue'
import FactoryShop from '../view/cloud/FactoryShop.vue'
// import sonOrder from '../view/sonOrder.vue'
// import colorProductDetail from '../view/cloud/colorProductDetail.vue'
// import cloudColorShopCar from '../components/cloud/CloudColorShopCar.vue'
// import AlbumManage from '../view/cloud/albumManage.vue'
// import memberService from '../view/cloud/memberService.vue'
import aboutSoftware from '../view/aboutSoftware'
// import supplierManage from '../view/cloud/supplierManage.vue'
// import inventoryBill from '../view/cloud/inventoryBill.vue'
// import MaterialList from '../view/cloud/MaterialList.vue'
// import ModelShop from '../view/cloud/ModelShop.vue'
import commodityDetail from '../view/cloud/commodityDetail_v2.vue'
import networkDetail from '../view/cloud/networkDetail1.vue'
// import Marketing from '../view/cloud/Marketing.vue'
Vue.use(VueRouter);

const changeFavicon = link => {
  let $favicon = document.querySelector('link[rel="icon"]');
  // If a <link rel="icon"> element already exists,
  // change its href to the given link.
  if ($favicon !== null) {
    $favicon.href = link;
    // Otherwise, create a new element and append it to <head>.
  } else {
    $favicon = document.createElement("link");
    $favicon.rel = "icon";
    $favicon.href = link;
    document.head.appendChild($favicon);
  }
};


const routes = [{
  path: '/',
  name: 'Shop',
  meta: {
    needUserInfo: false,
    needSupplierInfo: false,
    keepAlive: true
  },
  component: Shop
},
{
  path: '/showRoom',
  name: 'showRoom',
  meta: {
    needUserInfo: false,
    needSupplierInfo: false,
    keepAlive: true
  },
  component: showRoom
}, {
  path: '/TheWorld',
  name: 'TheWorld',
  meta: {
    needUserInfo: false,
    needSupplierInfo: false
  },
  component: TheWorld,
},{
  path: '/join',
  name: 'join',
  meta: {
    needUserInfo: false,
    needSupplierInfo: false,
    allowNoSupplier: true,
    backendNav: false
  },
  component: VipService
},
{
  path: '/aboutCloud',
  name: 'aboutCloud',
  meta: {
    needUserInfo: false,
    needSupplierInfo: false,
    allowNoSupplier: true,
    backendNav: false
  },
  component: AboutCloud
}, {
  path: '/moreVipServer',
  name: 'moreVipServer',
  meta: {
    needUserInfo: false,
    needSupplierInfo: false,
    allowNoSupplier: true,
    backendNav: false
  },
  component: MoreVipServer
}, {
  path: '/aboutSoftware',
  name: 'aboutSoftware',
  meta: {
    needUserInfo: false,
    needSupplierInfo: false,
    allowNoSupplier: true,
    backendNav: false
  },
  component: aboutSoftware
}, {
  path: '/personalCenter',
  name: 'personalCenter',
  redirect: {
    name: 'personalCenterInfo'
  },
  meta: {
    needUserInfo: true,
    needSupplierInfo: false,
    allowNoSupplier: true,
    backendNav: false,
    noFooter: true
  },
  component: PersonCenter,
  children: [{
    path: 'info',
    name: 'personalCenterInfo',
    component: () => import('../view/cloud/personalCenterInfo.vue')
  }, {
    path: 'orders',
    name: 'personalCenterOrders',
    component: () => import('../view/cloud/personalCenterOrders.vue')
  }, {
    path: 'shopcar',
    name: 'personalCenterShopCar',
    component: () => import('../view/cloud/personalCenterShopCar.vue')
  }, {
    path: 'submitOrder',
    name: 'SubmitOrder',
    component: () => import('../components/cloud/Order.vue'),
    meta: {
      keepAlive: false,
      needNav: false,
      needUserInfo: true,
    }
  }]
},
{
  path: '/networkDetail',
  name: 'networkDetail',
  component: networkDetail,
},
{
  path: '/commodityDetail',
  name: 'commodityDetail',
  component: commodityDetail,
  meta: {
    needUserInfo: true,
    needSupplierInfo: true,
    allowNoSupplier: true,
    noFooter: true
  }
}, {
  path: '/tableShopcar/:supplierId',
  name: 'TableShopCar',
  meta: {
    needUserInfo: true,
    needSupplierInfo: false,
    noFooter: true
  },
  component: TableShopCar,
}, {
  path: '/modelDisplay',
  name: 'ModelDisplay',
  meta: {
    needUserInfo: true,
    needSupplierInfo: false,
    noFooter: true
  },
  component: () => import ('../view/cloud/modelDisplay.vue')
}];

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
export function generateRouter(request, store) {
  const router = new VueRouter({
    routes
  });
  var navBefore = store.state.navNow
  // 目前跳转路由，需要让其他子组件不显示，要手动设置now为空，之后全部改造为路由后，可不用此逻辑
  router.beforeEach(async (to, from, next) => {
    let agent = 'pc'
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      agent = 'mobile'
    }
    // console.log(to)
    if (to.meta.noFooter) {
      store.commit('changeNoFooter', true)

    } else {
      store.commit('changeNoFooter', false)

    }
    // if (to.meta.backendNav) {
    //   store.commit('changeBackendNav', true)
    //   changeFavicon("https://eggrj.oss-cn-hangzhou.aliyuncs.com/logos/lbl.ico")
    //   document.title = '老板良后台管理系统'
    //   if (agent == 'mobile') {
    //     if (process.env.NODE_ENV === "development") {
    //       location.href = 'http://localhost:8010/cloudStorageMall.html#/supplierBackground'
    //     } else {
    //       location.href = './cloudStorageMall.html#/supplierBackground'
    //     }
    //   }
    // } else {
    //   store.commit('changeBackendNav', false)
    //   changeFavicon("https://eggrj.oss-cn-hangzhou.aliyuncs.com/logos/yc.ico")
    //   document.title = '柜柜云仓-实木颗粒板多层板生态板批发采购平台,全国建仓全国发货'
    //   if (agent == 'mobile') {
    //     if (process.env.NODE_ENV === "development") {
    //       location.href = 'http://localhost:8010/cloudStorageMall.html'
    //     } else {
    //       location.href = './cloudStorageMall.html'
    //     }

    //   }
    // }
    // console.log(store.state.noFooter)

    if (to.name == 'emptyPage') {
      store.commit('changeNavNow', navBefore)
      // store.state.navNow=navBefore
    }
    else {
      if (from.name == 'emptyPage') {
        navBefore = store.state.navNow
      }
      // store.state.navNow = '';
      store.commit('changeNavNow', '')
    }
    let param = autoLogin.getUrlVars()
    // console.log(param)
    if (param.hasOwnProperty('dfv')) {
      let dfv = JSON.parse(decodeURIComponent(param.dfv))
      store.commit('setUserDfv', dfv)
    }
    if (param.hasOwnProperty('p')) {
      let userInfo = await request.autoLogin(param.p, param.en)
      if (userInfo) {
        store.commit('setUserInfo', userInfo)
      }
      // console.log(to.path)
      location.href = autoLogin.deleteEnP()
      router.go(0)
      location.href = autoLogin.deleteEnP()
      // next({
      //   path:to.path
      // })
      // autoLogin.deleteEnP()
      // console.log(autoLogin.deleteEnP())
      // http://localhost:8080/#/storeManage?en=7d91679aeebb12fbb810f7c73736507b&p=MTUyMDg0NDU2MzI
      // location.href=autoLogin.deleteEnP()
      return
      // window.open(autoLogin.deleteEnP(),'_self')
    }

    if (localStorage.data && !store.state.userInfo.hasOwnProperty('id')) {
      console.log('');
      store.commit('setUserInfo', JSON.parse(localStorage.data))
    }

    // let can={} //0不通过，1正在进行，2通过
    if (to.meta.backendNav && to.meta.needUserInfo) {
      if (store.state.userInfo.hasOwnProperty('id')) {
        // can.userInfo=2
      } else {
        // can.userInfo=0
        // store.state.navNow = '首页'
        let pageTo = encodeURIComponent(location.href)
        if (process.env.NODE_ENV == "development") {
          location.href = 'https://www.guigui.com.cn/login.html?other=true&pageTo=' + pageTo
        } else {
          location.href = './login.html?pageTo=' + pageTo
        }
        return
      }
    } else {

    }


    if (to.meta.needSupplierInfo) {
      // can.supplierInfo=0
      // if (store.state.supplierInfo == "") {//是否正在请求
      //   can.supplierInfo=1
      //   var interval2 = setInterval(() => {
      //     if (store.state.supplierInfo != "") {
      //       clearInterval(interval2)
      //       if (!store.state.supplierInfo) { //不是供应商
      //         can.supplierInfo=0
      //       } else {
      //         can.supplierInfo=2
      //       }
      //     }
      //   }, 200)
      // } else {
      //   if (!store.state.supplierInfo) {
      //     can.supplierInfo=0
      //   } else {
      //     can.supplierInfo=2
      //   }
      // }

      if (store.state.userInfo.hasOwnProperty('id')) {
        if (store.state.supplierInfo) {
          // can.supplierInfo=2
        } else {
          // 重新获取供应商信息
          // console.log(1)
          // await store.commit('initSuppierInfo')
          let supplier = await request.getSupplierInfo({
            uid: store.state.userInfo.id
          })
          console.log('获取供应商信息： ', supplier);
          // console.log(3)
          // console.log(supplier)
          if (supplier) {
            store.commit('setSupplierInfo', supplier)
            // can.supplierInfo=2
          }
          store.commit('initUserInfo')
        }
      }
    }
    // let flag=2
    // for (let key in can){
    //   let item=can[key]
    //   if(item==1){//还在进行
    //     flag=1
    //     break;
    //   }
    //   if(item==0){//有不通过的
    //     flag=0
    //     break;
    //   }
    // }
    // if(flag==0){//不通过，非法访问，弹回首页
    //   // clearInterval(interval)
    //   store.state.navNow = '首页'
    //   next({
    //     path: '/'
    //   });
    // }
    // if(flag==2){//全部通过
    // clearInterval(interval)
    next()
    // }
    // var interval=setInterval(()=>{

    // },200)

  });
  return router;
}
// const router = new VueRouter({
//   routes
// });
// var navBefore = store.state.navNow
// // 目前跳转路由，需要让其他子组件不显示，要手动设置now为空，之后全部改造为路由后，可不用此逻辑
// router.beforeEach(async (to, from, next) => {
//   console.log('router.beforeEach')
//   if(to.meta.noFooter){
//     store.commit('changeNoFooter',true)
//   }else{
//     store.commit('changeNoFooter',false)
//   }
//   if(to.meta.backendNav){
//     store.commit('changeBackendNav',true)
//   }else{
//     store.commit('changeBackendNav',false)
//   }
//   // console.log(store.state.noFooter)
//   if (to.name == 'emptyPage') {
//     store.commit('changeNavNow',navBefore)
//     // store.state.navNow=navBefore
//   }
//   else {
//     if(from.name=='emptyPage'){
//       navBefore=store.state.navNow
//     }
//     // store.state.navNow = '';
//     store.commit('changeNavNow','')
//   }
//   let param=autoLogin.getUrlVars()
//   // console.log(param)
//   if(param.hasOwnProperty('p')){
//     let userInfo=await this.$autoLogin.autoLogin(param.p,param.en)
//     if(userInfo){
//       store.commit('setUserInfo',userInfo)
//     }
//     // console.log(to.path)
//     location.href=autoLogin.deleteEnP()
//     router.go(0)
//     location.href=autoLogin.deleteEnP()
//     // next({
//     //   path:to.path
//     // })
//     // autoLogin.deleteEnP()
//     // console.log(autoLogin.deleteEnP())
//     // http://localhost:8080/#/storeManage?en=7d91679aeebb12fbb810f7c73736507b&p=MTUyMDg0NDU2MzI
//     // location.href=autoLogin.deleteEnP()
//     return
//     // window.open(autoLogin.deleteEnP(),'_self')
//   }
//   if(localStorage.data&&!store.state.userInfo.hasOwnProperty('id')){
//     store.commit('setUserInfo',JSON.parse(localStorage.data))
//   }
//   // let can={} //0不通过，1正在进行，2通过
//   if(to.meta.needUserInfo){
//     if(store.state.userInfo.hasOwnProperty('id')){
//       // can.userInfo=2
//     }else{
//       // can.userInfo=0
//       // store.state.navNow = '首页'
//       store.commit('changeNavNow','首页')
//       next({
//         path: '/'
//       });
//       return
//     }
//   }
//   if(to.meta.needSupplierInfo){
//     // can.supplierInfo=0
//     // if (store.state.supplierInfo == "") {//是否正在请求
//     //   can.supplierInfo=1
//     //   var interval2 = setInterval(() => {
//     //     if (store.state.supplierInfo != "") {
//     //       clearInterval(interval2)
//     //       if (!store.state.supplierInfo) { //不是供应商
//     //         can.supplierInfo=0
//     //       } else {
//     //         can.supplierInfo=2
//     //       }
//     //     }
//     //   }, 200)
//     // } else {
//     //   if (!store.state.supplierInfo) {
//     //     can.supplierInfo=0
//     //   } else {
//     //     can.supplierInfo=2
//     //   }
//     // }
//     if(store.state.userInfo.hasOwnProperty('id')){
//       if(store.state.supplierInfo){
//         // can.supplierInfo=2
//       }else{
//         // console.log(1)
//         // await store.commit('initSuppierInfo')
//         let supplier=await this.$autoLogin.getSupplierInfo(store.state.userInfo.id)
//         // console.log(3)
//         // console.log(supplier)
//         if(supplier){
//           store.commit('setSupplierInfo',supplier)
//           // can.supplierInfo=2
//         }else{
//           // can.supplierInfo=0
//           if(!to.meta.allowNoSupplier){
//             store.commit('changeNavNow','首页')
//             next({
//               path: '/'
//             });
//             return
//           }
//         }
//       }
//     }
//   }
//   // let flag=2
//   // for (let key in can){
//   //   let item=can[key]
//   //   if(item==1){//还在进行
//   //     flag=1
//   //     break;
//   //   }
//   //   if(item==0){//有不通过的
//   //     flag=0
//   //     break;
//   //   }
//   // }
//   // if(flag==0){//不通过，非法访问，弹回首页
//   //   // clearInterval(interval)
//   //   store.state.navNow = '首页'
//   //   next({
//   //     path: '/'
//   //   });
//   // }
//   // if(flag==2){//全部通过
//     // clearInterval(interval)
//     next()
//   // }
//   // var interval=setInterval(()=>{
//   // },200)
// })

// export default router;
// key]
//   //   if(item==1){//还在进行
//   //     flag=1
//   //     break;
//   //   }
//   //   if(item==0){//有不通过的
//   //     flag=0
//   //     break;
//   //   }
//   // }
//   // if(flag==0){//不通过，非法访问，弹回首页
//   //   // clearInterval(interval)
//   //   store.state.navNow = '首页'
//   //   next({
//   //     path: '/'
//   //   });
//   // }
//   // if(flag==2){//全部通过
//     // clearInterval(interval)
//     next()
//   // }
//   // var interval=setInterval(()=>{
//   // },200)
// })

// export default router;
